export const ANIMATION = {
  SPEED: 200,
  ANIMATED: "animated",
};
